import {Controller} from '@hotwired/stimulus'


export default class extends Controller {
  static targets = ['deletedItemsInfo', 'additionalItemsLabel']

  connect() {
  }

  deleteRow(event) {
    event.target.closest('.add-item-field').remove()
    let type = event.target.closest('button').dataset.type

    if (type && this.hasDeletedItemsInfoTarget) {
      this.deletedItemsInfoTarget.value = type
      this.deletedItemsInfoTarget.classList.remove('d-none')
    }
  }

  addItem() {
    this.additionalItemsLabelTarget.classList.remove('d-none')
  }
}
